export default function (context) {
    const inputs = $('textarea.trumbowyg', context)
    const getColors = function () {
        try {
            return textEditorColors;
        } catch (e) {
            return null;
        }
    }
    inputs.each(function () {
        const input = $(this)
        input.trumbowyg({
            lang: $('html').attr('lang'),
            resetCss: false,
            autogrow: false,
            autogrowOnEnter: false,
            btns: [
                // ['viewHTML'],
                ['undo', 'redo'], // Only supported in Blink browsers
                // ['formatting'],
                ['strong', 'em'],
                ['foreColor', 'backColor'],
                // ['link'],
                // ['insertImage'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                // ['indent', 'outdent'],
                ['unorderedList', 'orderedList'],
                ['horizontalRule'],
                ['removeformat'],
                ['emoji'],
                ['ltr', 'rtl'],
                ['link'],
            ],
            btnsDef: {
                formatting: {
                    dropdown: ['p', 'h3'],
                }
            },
            removeformatPasted: false,
            defaultLinkTarget: '_blank',
            minimalLinks: true,
            tagsToRemove: ['script', 'link', 'iframe', 'embed', 'input'],
            tagClasses: {},
            plugins: {
                allowTagsFromPaste: {
                    allowedTags: ['p', 'br', 'b', 'i', 'em', 'strong', 'li', 'ul', 'span', 'a']
                },
                colors: {
                    colorList: getColors(),
                    allowCustomForeColor: false,
                    allowCustomBackColor: false,
                }
            }
        }).on('tbwchange', function(e){
            $(this).addClass('changed');
        })
        const newContainer = input.closest('.form-group').find('.trumbowyg-editor');
        if (newContainer.length > 0) {
            const currentId = input.attr('id');
            const newId = currentId + '_trumbowyg-editor';
            newContainer.attr('id', newId);
            newContainer.attr('role', 'main'); // to force screen reader to read labels for it
            newContainer.attr('tabindex', '0');
            input.closest('.form-group').find('label').attr('for', newId);
        }
    })
}
